import React, { Fragment, memo, useMemo } from "react";
import { type HeadingProps, SupHeading } from "@repo/core-ui";

export type ErrorProps = HeadingProps & {
  message: string;
};

const GLITCHES = "`¡™£¢∞§¶•ªº–≠åß∂ƒ©˙∆˚¬…æ≈ç√∫˜µ≤≥÷/?░▒▓<>/".split("");
const STEPS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

function generateStyles(index: number) {
  return STEPS.reduce<Record<string, string | number>>(
    (styles, step) => ({
      ...styles,
      [`--char-${step}`]: `"${GLITCHES[Math.floor(Math.random() * GLITCHES.length)]}"`,
    }),
    { "--char-index": index }
  );
}

function SupError({ message = "", variant, ...rest }: ErrorProps) {
  const words = useMemo(() => message.split(" ").map(word => word.split("")), [message]);
  let index = 0;

  return (
    <SupHeading variant={variant} {...rest}>
      {words.map((word, i) => (
        <Fragment key={i}>
          <span className="sup-error-word whitespace-nowrap">
            {word.map(char => {
              const styles = generateStyles(index);
              index++;

              return <span key={`${char}-${index}`} data-char={char} className="sup-error-char" style={styles} />;
            })}
          </span>
          {i < words.length - 1 && " "}
        </Fragment>
      ))}
    </SupHeading>
  );
}

export default memo(SupError);
